import { render, staticRenderFns } from "./TipoUsoForm.vue?vue&type=template&id=14534672&lang=html"
import script from "./TipoUsoForm.vue?vue&type=script&lang=js"
export * from "./TipoUsoForm.vue?vue&type=script&lang=js"
import style0 from "./TipoUsoForm.vue?vue&type=style&index=0&id=14534672&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports